/*
 * The curated learning paths.
 *
 * Moved out of the page component so the build-time sitemap and prerender can
 * read it too — the same reason src/seo/libraryMeta.js exists. These listings
 * are public now, so they need to be in the sitemap and to arrive as real HTML
 * for anything that does not run JavaScript.
 *
 * CommonJS so webpack and plain node can both load it.
 */

const LEARNING_PATHS = {
  ai: {
    slug:        'ai',
    label:       '30 Days of AI',
    labelKey:    'learningPath.aiLabel',
    descKey:     'learningPath.aiDesc',
    progressNoteKey: 'learningPath.aiProgress',
    shortLabel:  'AI',
    icon:        '🧠',
    tagSlug:     '30-days-of-ai',
    totalDays:   30,
    accentFrom:  '#059669',
    accentTo:    '#10b981',
    accentBg:    'rgba(5,150,105,0.1)',
    accentBorder:'rgba(5,150,105,0.3)',
    accentText:  '#6ee7b7',
    description: 'AI for Cloud & DevOps engineers — from LLM fundamentals to building agentic systems, deploying models on Kubernetes, and securing AI in production.',
    progressNote: 'All 30 days published',
    allAccessible: true,
  },
  mlops: {
    slug:        'mlops',
    label:       '30 Days of MLOps',
    labelKey:    'learningPath.mlopsLabel',
    descKey:     'learningPath.mlopsDesc',
    shortLabel:  'MLOps',
    icon:        '🤖',
    tagSlug:     '30-days-of-mlops',
    totalDays:   30,
    accentFrom:  '#7c3aed',
    accentTo:    '#a855f7',
    accentBg:    'rgba(124,58,237,0.1)',
    accentBorder:'rgba(124,58,237,0.3)',
    accentText:  '#c4b5fd',
    description: 'Master MLOps in 30 days — from ML pipelines to production deployment, model monitoring, and automation.',
    // Surfaced on this path's page so readers of the 30-day series can find the
    // longer, in-progress one. Both are separate series with their own articles.
    relatedPath: 'mlops-100',
  },
  'mlops-100': {
    slug:        'mlops-100',
    label:       '100 Days of MLOps',
    labelKey:    'learningPath.mlops100Label',
    descKey:     'learningPath.mlops100Desc',
    shortLabel:  'MLOps 100',
    icon:        '🚀',
    tagSlug:     '100-days-of-mlops',
    totalDays:   100,
    accentFrom:  '#be185d',
    accentTo:    '#ec4899',
    accentBg:    'rgba(190,24,93,0.1)',
    accentBorder:'rgba(190,24,93,0.3)',
    accentText:  '#f9a8d4',
    description: 'The deep-dive MLOps track — 100 days from fundamentals and tooling to production pipelines, model serving on Kubernetes, monitoring, and scale.',
    relatedPath: 'mlops',
  },
  devops: {
    slug:        'devops',
    label:       '60 Days of DevOps',
    labelKey:    'learningPath.devopsLabel',
    descKey:     'learningPath.devopsDesc',
    shortLabel:  'DevOps',
    icon:        '🔄',
    tagSlug:     '60-days-of-devops',
    totalDays:   60,
    accentFrom:  '#4f46e5',
    accentTo:    '#7c3aed',
    accentBg:    'rgba(99,102,241,0.1)',
    accentBorder:'rgba(99,102,241,0.3)',
    accentText:  '#a5b4fc',
    description: 'A structured 60-day journey from DevOps fundamentals to advanced practices — CI/CD, containers, Kubernetes, monitoring, and more.',
  },
  cloud: {
    slug:        'cloud',
    label:       '90 Days of Cloud',
    labelKey:    'learningPath.cloudLabel',
    descKey:     'learningPath.cloudDesc',
    progressNoteKey: 'learningPath.cloudProgress',
    shortLabel:  'Cloud',
    icon:        '☁️',
    tagSlug:     '90-days-of-cloud',
    totalDays:   90,
    accentFrom:  '#0284c7',
    accentTo:    '#0ea5e9',
    accentBg:    'rgba(2,132,199,0.1)',
    accentBorder:'rgba(2,132,199,0.3)',
    accentText:  '#7dd3fc',
    description: 'Your 90-day cloud mastery roadmap — AWS (Days 1–30), with GCP and Azure chapters coming next.',
    progressNote: 'Days 1–30 (AWS) published',
  },
};

/* Public listings. The AI roadmap generator at /learning-paths/roadmap is a
 * per-member tool with a quota, so it is not one of these. */
const LEARNING_PATH_LIST = Object.values(LEARNING_PATHS);

const SITE = 'https://app.learnxops.com';

function learningPathUrl(slug) {
  return `${SITE}/learning-paths/${slug}`;
}

/** The <head> for one path, shared by the page and the prerender. */
function learningPathMeta(path) {
  return {
    title: `${path.label} — Free Learning Path`,
    description: path.description,
    canonical: learningPathUrl(path.slug),
  };
}

module.exports = { LEARNING_PATHS, LEARNING_PATH_LIST, learningPathUrl, learningPathMeta };
